import Cargando from 'components/Varios/Cargando';
import IconCloseModal from 'components/Varios/Modals/IconCloseModal';
import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { Container, Modal, ModalBody, ModalFooter, ModalHeader, Row, Col, FormGroup, Label, Input, Button, CustomInput } from "reactstrap"
import { FechasPermisosMedicosVacaciones, PlanificacionSolicitudVacaciones, Replanificacion, SolicitudVacaciones } from '../TypesSolicitudVacaciones';
import { SumDiasOrdinariosReplanificaciones } from './FunctionsModalAcciones';
import { ObtenerFechaFromIsoFormat, PruebaSolucion2, function_calcular_dias_ordinarios } from 'functions/DatesFunctions';
import { classNameIconoMenos } from 'constants/Icons-Font-Awesome';
import TablePlanificaciones from '../TablePlanificaciones';
import AgregarReprogramacion from '../Componentes Reprogramacion/AgregarReprogramacion';
import { verificarFechasContenidas } from './ModalReintegro';

export type PropsModalConfirmacion = {
    show: boolean,
    size: "xl" | "sm" | "md" | "lg",
    asyncAccion: boolean,
    asyncClose: boolean,
    onClose: () => void,
    asyncAfterOnClose?: () => Promise<void>,
    onClick?: (observacion: string) => void,
    asyncOnClick?: (observacion: string, listadoReplanifificacion: Replanificacion[]) => Promise<number>;
    mensajeConfirmacion: string,
    classNamemensajeConfirmacion?: string,
    nombreBotonAccion: string,
    nombreBotonCerrarModal?: string,
    nombreBotonAfterOnClose?: string,
    closeAfterAccion: boolean
    hideBotonCerrar: boolean,
    contentModal?: HTMLElement | React.ReactElement
    tituloModal?: string
    labelObservacion: string
    botonesAccionParteSuperior?: boolean,
    cargando?: boolean,

    //Propiedades para reprogramacion de vacaciones
    solicitudes: SolicitudVacaciones[],
    solicitudVacaciones: SolicitudVacaciones,
    planificaciones: PlanificacionSolicitudVacaciones[],
    anioPlanificacion: number,
    feriados: Date[],
    fechasPermisosMedicos: FechasPermisosMedicosVacaciones[],
    fechasLicencia: {
        fechadesde: Date,
        fechahasta: Date,
    }[],

    maxLength: number,
    fechaCorteSoloJustificaPlanificacion: Date


}

type StateModalConfirmacion = {
    realizandoAccion: boolean,
    accionTerminada: boolean,
    errorAsyncAccion: boolean,
    observacion: string
}

export default function ModalAccionAnularSolicitudAprobada(props: PropsModalConfirmacion) {

    const initialState: StateModalConfirmacion = {
        realizandoAccion: false,
        accionTerminada: false,
        errorAsyncAccion: false,
        observacion: ""
    }




    const [stateModal, setstateModal] = useState<StateModalConfirmacion>(initialState);


    //States de la planificacion que esta siendo Ingresada
    const [fechaDesdePlanificacion, setfechaDesdePlanificacion] = useState<Date | undefined>(undefined)
    const [fechaHastaPlanificacion, setfechaHastaPlanificacion] = useState<Date | undefined>(undefined)
    const [servidorReprogramaraFechaOpcional, setservidorReprogramaraFechaOpcional] = useState<boolean>(false)
    //State de Lista de Replanificaciones
    const [listadoReplanificaciones, setlistadoReplanificaciones] = useState<Replanificacion[]>([])


    
    const debeReprogramar: boolean = props.planificaciones.length > 0 && !props.solicitudVacaciones.permiso && verificarFechasContenidas(props.solicitudVacaciones, props.planificaciones) ;

    const diasReprogramados: number = SumDiasOrdinariosReplanificaciones(listadoReplanificaciones);

    const diasPendientesPorReprogramar: number = props.solicitudVacaciones.diasOrdinarios - diasReprogramados;

    /*Esto es para simular que se ha llegado al periodo en que no es obligatoria la reprogramación
        const fechaActual = new Date(2023, 12, 12);
    */

    const fechaActual = new Date();

    const ReprogramacionOpcionalPorFecha: boolean = fechaActual.getTime() >= new Date(props.fechaCorteSoloJustificaPlanificacion).getTime()


    function CerrarModal() {
        setstateModal(initialState);
        props.onClose();
    }

    async function CerrarModalAndAfterClose(callbackClose: () => Promise<void>) {
        setstateModal(initialState);
        await callbackClose();

    }

    const AccionAsync = useCallback(
        async (callbackAccion: any) => {
            const { asyncAfterOnClose } = props;
            setstateModal({ ...stateModal, realizandoAccion: true })
            var statusAccion = await callbackAccion(stateModal.observacion,listadoReplanificaciones);

            if (props.closeAfterAccion && typeof (asyncAfterOnClose) === "function") {
                await CerrarModalAndAfterClose(asyncAfterOnClose);
            }
            else if (props.closeAfterAccion && typeof (asyncAfterOnClose) === "undefined") {
                CerrarModal();
            }

            else {
                if (statusAccion > -1) {
                    setstateModal({ ...stateModal, realizandoAccion: false, accionTerminada: true })
                }
                else {
                    setstateModal({ ...stateModal, realizandoAccion: false, accionTerminada: true, errorAsyncAccion: true })
                }
            }

        },
        [stateModal,listadoReplanificaciones],
    )


    function AccionNotAsync(callbackAccion: any) {

        const { closeAfterAccion } = props;
        callbackAccion();

        if (closeAfterAccion) {
            CerrarModal();
        }
    }

    const BotonCerrar = useMemo(() => {
        return (
            <IconCloseModal handleClickIcon={() => CerrarModal()} />
        )
    }, [props])


    const BotonCancelar = useMemo(() => {
        return (
            <Button color="secondary" disabled={stateModal.realizandoAccion} onClick={() => CerrarModal()}> {props.nombreBotonCerrarModal !== undefined ? props.nombreBotonCerrarModal : "Cerrar Mensaje"} </Button>
        )
    }, [stateModal, props])

    const BotonAccion = useMemo(() => {
        const { asyncOnClick, onClick } = props;


        var condicionReprogramacion = (debeReprogramar && listadoReplanificaciones.length === 0)
        if (debeReprogramar && ReprogramacionOpcionalPorFecha && !servidorReprogramaraFechaOpcional) {
            condicionReprogramacion = false
        }
        else if (debeReprogramar && ReprogramacionOpcionalPorFecha && servidorReprogramaraFechaOpcional && listadoReplanificaciones.length == 1) {
            condicionReprogramacion = true
        }
        

        const disabled = stateModal.observacion === "" || stateModal.observacion === "def" || condicionReprogramacion || (debeReprogramar && !ReprogramacionOpcionalPorFecha && diasPendientesPorReprogramar > 0)





        if (props.asyncAccion && asyncOnClick) {
            return (
                <Button color="primary" disabled={disabled} className="mr-2" onClick={async () => await AccionAsync(asyncOnClick)}>{props.nombreBotonAccion}</Button>
            )
        }
        else if (!props.asyncAccion && onClick) {
            return (
                <Button color="primary" disabled={disabled} className="mr-2" onClick={() => AccionNotAsync(onClick)}>{props.nombreBotonAccion}</Button>
            )
        }
        else {
            return (<div></div>)
        }


    }, [props, stateModal, stateModal, listadoReplanificaciones, diasPendientesPorReprogramar, debeReprogramar, ReprogramacionOpcionalPorFecha, servidorReprogramaraFechaOpcional])

    const BotonCerrarYAccion = useMemo(() => {
        const { asyncAfterOnClose, nombreBotonAfterOnClose } = props

        if (asyncAfterOnClose && nombreBotonAfterOnClose) {
            return (
                <Button color="primary" id="botonAfterOnClose" className="mr-2" onClick={async () => await CerrarModalAndAfterClose(asyncAfterOnClose)}>{nombreBotonAfterOnClose ?? "Cerrar y Continuar"}</Button>
            )
        }
    }, [props, stateModal])


    const ListadoReprogramacionesComponent = useMemo(() => {


        if (listadoReplanificaciones.length > 0 && stateModal.observacion !== "") {


            return (
                <React.Fragment>



                    {listadoReplanificaciones.map((v, i) => {
                        const fechaDesdeString = v.editable ? ObtenerFechaFromIsoFormat(PruebaSolucion2(v.fechaInicio)) : ObtenerFechaFromIsoFormat(v.fechaInicio.toString());
                        const fechaHastaString = v.editable ? ObtenerFechaFromIsoFormat(PruebaSolucion2(v.fechaFin)) : ObtenerFechaFromIsoFormat(v.fechaFin.toString());
                        if (v.showInTable !== undefined && v.showInTable === false) {
                            return undefined;
                        }
                        return (
                            <Row className="mb-2">
                                <Col xl={3} lg={2} md={12}>
                                    <Input className="marginModRein" type="text" value={fechaDesdeString} readOnly id={"reprogramacionReintegroDesde " + i} ></Input>
                                </Col>
                                <Col xl={3} lg={2} md={12}>
                                    <Input className="marginModRein" type="text" value={fechaHastaString} readOnly id={"reprogramacionReintegroHasta " + i} ></Input>
                                </Col>
                                <Col xl={3} lg={2} md={12}>
                                    <Input className="marginModRein" type="text" value={v.diasOrdinarios} readOnly id={"reprogramacionReintegroDias " + i} ></Input>
                                </Col>
                                {
                                    v.editable !== undefined && v.editable &&
                                    (
                                        <Col sm={1} md={1} className="columnIconMinusReprogramacion">
                                            <i
                                                className={classNameIconoMenos}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Eliminar"
                                                onClick={() => onClickRemoverReplanificacion(v)}
                                            />

                                        </Col>
                                    )
                                }

                            </Row>
                        )
                    })}
                </React.Fragment>

            )

        }
    }, [listadoReplanificaciones, stateModal.observacion])

    const FechaAReprogramarComponent = () => {
        const solicitudVacaciones = props.solicitudVacaciones
        const diasOrdinarios = solicitudVacaciones.diasOrdinarios;
        const classNameFormGroup = "mb-0";
        const classNameLabel = "labelAReprogramar";
        const classNameInput = "inputAReprogramar"

        return (
            <React.Fragment>
                <Row className="justify-content-start">
                    <Col xl={12}>
                        <p className='text-reprogramar'>{"Usted va a reprogramar la fecha de solicitud: "}</p>
                    </Col>
                </Row>

                <Row className="rowContainerFechaAReprogramar">
                    <Col xl={3} lg={2} md={12}>
                        <FormGroup className={classNameFormGroup}>
                            <Label for="fecha1DesdeReprogramacion" className={classNameLabel}>
                                {"Fecha Desde"}
                            </Label>

                            <Input className={classNameInput} type="text" value={ObtenerFechaFromIsoFormat(solicitudVacaciones.fechaInicio.toString())} readOnly  ></Input>
                        </FormGroup>
                    </Col>
                    <Col xl={3} lg={2} md={12}>
                        <FormGroup className={classNameFormGroup}>
                            <Label for="fecha1HastaReprogramacion" className={classNameLabel}>
                                {"Fecha hasta"}
                            </Label>

                            <Input className={classNameInput} type="text" value={ObtenerFechaFromIsoFormat(solicitudVacaciones.fechaFin.toString())} readOnly ></Input>
                        </FormGroup>
                    </Col>
                    <Col xl={3} lg={2} md={12}>
                        <FormGroup className={classNameFormGroup}>
                            <Label for="nroDiasOrdinariosReprogramacion" className={classNameLabel}>
                                {"Nro días Ordinarios"}
                            </Label>

                            <Input className={classNameInput} type="text" value={diasOrdinarios} readOnly  ></Input>
                        </FormGroup>
                    </Col>
                </Row>



                <Row className="justify-content-start">
                    <Col xl={12}>
                        <p className='mb-0 labelReprogranacionReintegro'>{"Reprogramación"}</p>
                    </Col>
                </Row>
            </React.Fragment>
        )

    }




    useEffect(() => {
        if (!servidorReprogramaraFechaOpcional) {
            setlistadoReplanificaciones([])
        }
    }, [servidorReprogramaraFechaOpcional])


    function AddReplanificacion(listado: Replanificacion[], fechaDesde: Date, fechaHasta: Date) {
        const diasOrdinarios: number = function_calcular_dias_ordinarios(fechaDesde, fechaHasta);

        setlistadoReplanificaciones([
            ...listado,
            {
                fechaInicio: fechaDesde,
                fechaFin: fechaHasta,
                diasOrdinarios,
                editable: true,
                showInTable: true
            }
        ])

        setfechaDesdePlanificacion(undefined);
        setfechaHastaPlanificacion(undefined);
    }

    const onClickRemoverReplanificacion = useCallback(
        (replanificacion: Replanificacion) => {
            if (listadoReplanificaciones.length > 0) {


                const listadoNuevo = [...listadoReplanificaciones].filter((val) => !(val.fechaFin.getTime() === replanificacion.fechaFin.getTime() && val.fechaInicio.getTime() === replanificacion.fechaInicio.getTime()))

                setlistadoReplanificaciones(listadoNuevo)



                const totalDiasReplanificados = listadoNuevo.reduce((acum, cval) => acum + cval.diasOrdinarios, 0);
            }
        },
        [listadoReplanificaciones],
    )




    const ContenidoModal = useMemo(() => {
        const { accionTerminada, realizandoAccion, errorAsyncAccion, observacion } = stateModal;
        const { asyncClose } = props;


        const botonesAcciones = (
            <>
                {!realizandoAccion && !accionTerminada && BotonAccion}
                {!realizandoAccion && accionTerminada && asyncClose && !errorAsyncAccion && BotonCerrarYAccion}
                {!props.hideBotonCerrar && !realizandoAccion && BotonCancelar}

            </>
        )

        var parteinicial = (
            <React.Fragment>
                <Row className="justify-content-center">
                    {
                        !realizandoAccion && !accionTerminada &&
                        <p className={`text-center ${props.classNamemensajeConfirmacion}`}>{props.mensajeConfirmacion}</p>
                    }
                </Row>
                {
                    stateModal.observacion === "" &&
                    <Row>
                        <Col md={12} sm={12}>
                            <small className='small-error'>Indique motivo de negado para habilitar boton</small>
                        </Col>

                    </Row>

                }
            </React.Fragment>

        )

        if (props.botonesAccionParteSuperior !== undefined && props.botonesAccionParteSuperior === true) {

            parteinicial = (
                <React.Fragment>
                    <Row className="justify-content-start">
                        {
                            !realizandoAccion && !accionTerminada &&
                            <Col xl={8} lg={8} md={12}>
                                <p className={`text-center ${props.classNamemensajeConfirmacion}`}>{props.mensajeConfirmacion}</p>
                            </Col>
                        }

                        {!realizandoAccion && !accionTerminada && <Col xl={1} lg={1} md={6}>{BotonAccion}</Col>}
                        {!realizandoAccion && accionTerminada && asyncClose && !errorAsyncAccion && <Col xl={1} lg={1} md={6} className="d-flex ">{BotonCerrarYAccion}</Col>}
                        {!props.hideBotonCerrar && !realizandoAccion && <Col xl={1} lg={1} md={6} className="d-flex ">{BotonCancelar}</Col>}

                    </Row>
                    {
                        stateModal.observacion === "" &&
                        <Row className="mb-2">
                            <Col md={12} sm={12} className="text-center">
                                <small className='small-error'>Indique motivo de negado para habilitar boton</small>
                            </Col>

                        </Row>

                    }

                </React.Fragment>

            );
        }

        if (props.cargando !== undefined && props.cargando === true) {
            return (
                <Cargando />
            )
        }

        return (
            <Container>

                {
                    parteinicial
                }


                {
                    props.contentModal
                }

                <Row className="justify-content-center mb-3">
                    <Col>
                        <FormGroup>
                            <Label for="estadoSolicitud">
                                {props.labelObservacion + ` (hasta ${props.maxLength} caracteres)*`}
                            </Label>
                            <Input
                                id="observacionRechazo"
                                name="observacionRechazo"
                                type="textarea"
                                rows="5"
                                value={observacion}
                                maxLength={props.maxLength}
                                onChange={(e) => setstateModal({ ...stateModal, observacion: e.target.value })}
                            />
                        </FormGroup>
                    </Col>

                </Row>

                {
                    debeReprogramar && stateModal.observacion !== "" &&
                    <React.Fragment>
                        {ReprogramacionOpcionalPorFecha &&
                            <Row>
                                <Col sm={12} md={12}>
                                    <FormGroup tag="fieldset">
                                        <div className='ParentCheckReplanificar'>
                                            <div className='textReplanificar'>{"¿Desea replanificar? "}</div>
                                            <div>
                                                <FormGroup check inline>

                                                    <Label check>
                                                        <Input checked={servidorReprogramaraFechaOpcional} disabled={!debeReprogramar} onChange={(e) => setservidorReprogramaraFechaOpcional(true)} type="radio" />
                                                        {"Si"}
                                                    </Label>
                                                </FormGroup>
                                                <FormGroup check inline>
                                                    <Label check>
                                                        <Input checked={!servidorReprogramaraFechaOpcional} disabled={!debeReprogramar} onChange={(e) => setservidorReprogramaraFechaOpcional(false)} type="radio" />
                                                        {"No"}
                                                    </Label>
                                                </FormGroup>
                                            </div>

                                        </div>


                                    </FormGroup>



                                </Col>
                            </Row>
                        }



                        <React.Fragment>
                            {
                                (!ReprogramacionOpcionalPorFecha || (ReprogramacionOpcionalPorFecha && servidorReprogramaraFechaOpcional)) &&
                                <React.Fragment>
                                    <TablePlanificaciones
                                        celdaCheck={() => { return <></> }}
                                        showColumnSeleccionar={false}
                                        planificacionesDelAnio={props.planificaciones}
                                        anio={props.anioPlanificacion}

                                    />

                                    {FechaAReprogramarComponent()}

                                    {ListadoReprogramacionesComponent}

                                    {
                                        diasPendientesPorReprogramar > 0 && !ReprogramacionOpcionalPorFecha &&
                                        (<Row className="mt-2">
                                            <Col md={12}>
                                                <small className='small-error'> {`Para habilitar el botón debe reprogramar ${diasPendientesPorReprogramar} día(s) ordinario(s)`}</small>
                                            </Col>
                                        </Row>)
                                    }

                                    {
                                         diasPendientesPorReprogramar > 0 && ReprogramacionOpcionalPorFecha &&
                                        (<Row className="mt-2">
                                            <Col md={12}>
                                                <small className='small-error'> {`Puede reprogramar hasta ${diasPendientesPorReprogramar} día(s) ordinario(s)`}</small>
                                            </Col>
                                        </Row>)
                                    }


                                    {
                                        <AgregarReprogramacion
                                            diasPendientes={diasPendientesPorReprogramar}
                                            fechaDesdeReprogramacion={fechaDesdePlanificacion}
                                            onChangeDateDesde={(e) => setfechaDesdePlanificacion(e)}
                                            fechaHastaReprogramacion={fechaHastaPlanificacion}
                                            onChangeDateHasta={(e) => setfechaHastaPlanificacion(e)}
                                            onClickLimpiarReprogramacion={() => { setfechaDesdePlanificacion(undefined); setfechaHastaPlanificacion(undefined) }}

                                            fechasLicencia={props.fechasLicencia}
                                            fechasPermisosMedicos={props.fechasPermisosMedicos}
                                            feriados={props.feriados}
                                            solicitudes={props.solicitudes}
                                            solicitudesReintegro={[]}
                                            solicitudVacacionDeReintegro={props.solicitudVacaciones}

                                            justificacionReplanificada={true}
                                            listadoReplanificaciones={listadoReplanificaciones}
                                            mostrarComponente={true}
                                            mensajeErrorListadoReplanificaciones=''
                                            mensajeErrorPlanificacion=''
                                            onAddReprogramacion={(fd: Date, fh: Date) => AddReplanificacion(listadoReplanificaciones, fd, fh)}
                                            planificaciones={props.planificaciones}
                                            permitirMenosDias={true}
                                            solicitudReprogramando='anulacion'
                                        />
                                    }

                                </React.Fragment>
                            }


                        </React.Fragment>



                    </React.Fragment>

                }





                <Row className="justify-content-center">

                    {
                        (props.botonesAccionParteSuperior === undefined || (props.botonesAccionParteSuperior !== undefined && props.botonesAccionParteSuperior === false))
                        && botonesAcciones
                    }


                </Row>
                <Row>
                    <Col>
                        {
                            realizandoAccion && !accionTerminada &&
                            <Row className="justify-content-center">
                                <Cargando />
                            </Row>
                        }
                    </Col>

                </Row>
                <Row className="justify-content-center">
                    <Col>
                        {
                            !realizandoAccion && accionTerminada && !errorAsyncAccion &&
                            <p className='error-small'>Se ha completado la acción</p>
                        }
                        {
                            !realizandoAccion && accionTerminada && errorAsyncAccion &&
                            <p className='error-small'>Ha ocurrido un inconveniente al tratar de realizar la acción</p>
                        }
                    </Col>
                </Row>
            </Container>
        )
    }, [props, stateModal,listadoReplanificaciones, fechaDesdePlanificacion, fechaHastaPlanificacion, servidorReprogramaraFechaOpcional])

    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={props.size}
            fullscreen={props.size}
            centered={false}
            onClosed={() => CerrarModal()}
            contentClassName="contentReintegro"

        >
            <ModalHeader close={BotonCerrar}>
                <div className='tituloModalDocumentos'>{props.tituloModal ? props.tituloModal : "Mensaje de confirmación"}</div>
            </ModalHeader>
            <ModalBody>
                <>

                    {ContenidoModal}
                </>

            </ModalBody>

        </Modal>
    )
}
